import { Outlet } from 'react-router-dom';

export const OutputsOutlet = () => <Outlet />;
